const methods = {
  // 버튼 얼럿
  buttonAlert(value) {
    return alert(value)
  },
}

export default methods
